var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleLeftDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.64,
    height: 15.984,
    viewBox: "0 0 20.64 15.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1329",
    "data-name": "Group 1329",
    transform: "translate(-21.5 -65.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M216,221.145l11.64-6.566L216,207.932Z",
    transform: "translate(257.14 287.957) rotate(180)",
    fill: "none",
    stroke: "#07b4e8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M216,207.932l10,6.647-10,6.566",
    transform: "translate(248.5 287.957) rotate(180)",
    fill: "none",
    stroke: "#07b4e8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLeftDate);
export default __webpack_public_path__ + "static/media/doubleLeftDate.b133b77ac7a1369cfc21cadb1aaede05.svg";
export { ForwardRef as ReactComponent };